export default "__VITE_ASSET__DQCzqmX8__"